export default __webpack_public_path__ + "static/media/3.f2662c01.jpg";